import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Page, Pageable} from "../../model/rest/base";
import {IdentifiedRoomTemplate, RoomDef} from "../../model/server";
import {Observable} from "rxjs";
import {ScheduleRow} from "../../model/schedule";

@Injectable({
  providedIn: 'root'
})
export class StudentVideoRestService {
  constructor(private http: HttpClient) {
  }

  prepareUrl(schoolId: number, studentId: number, path: string): string {
    return `${environment.videoApiBase}/sec/school/${schoolId}/student/${studentId}${path}`;
  }

  public listTemplates(schoolId: number, studentId: number, pageable: Pageable): Observable<Page<IdentifiedRoomTemplate>> {
    const params = Pageable.appedPageableParams(new HttpParams(), pageable);
    return this.http.get<Page<IdentifiedRoomTemplate>>(this.prepareUrl(schoolId, studentId, "/templates"), {params});
  }

  public listRooms(schoolId: number, studentId: number, pageable: Pageable): Observable<Page<RoomDef>> {
    const params = Pageable.appedPageableParams(new HttpParams(), pageable);
    return this.http.get<Page<RoomDef>>(this.prepareUrl(schoolId, studentId, "/rooms"), {params});
  }

  public listSchedules(schoolId: number, studentId: number, focusDate: number) {
    const params = new HttpParams().append("focusDate", focusDate.toString());
    return this.http.get<ScheduleRow[]>(this.prepareUrl(schoolId, studentId, "/schedules"), {params})
  }

  public getRoomDetails(schoolId: number, studentId: number, roomUuid: string): Observable<RoomDef> {
    return this.http.get<RoomDef>(this.prepareUrl(schoolId, studentId, `/rooms/${roomUuid}`));
  }

  public getScheduleDetails(schoolId: number, studentId: number, scheduleId: number) {
    return this.http.get<ScheduleRow>(this.prepareUrl(schoolId, studentId, `/schedules/${scheduleId}`), );
  }
}
